/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * MessageBubblesIcon
 */
export default class MessageBubblesIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M8.933 2c1.835 0 3.585.443 5.056 1.268 2.036 1.14 3.483 2.992 3.992 5.536l-.035-.162c3.36.603 5.92 3.053 5.92 6.074 0 1.388-.4 2.648-1.196 3.75l.834 1.476a1.77 1.77 0 01-2.278 2.478l-3.244-1.488h-1.63c-3.553.13-6.196-1.471-7.157-3.995-.814.04-1.646.01-2.326-.089l-3.94 1.832a1.945 1.945 0 01-2.52-2.71l1.089-1.953C.502 12.673 0 11.13 0 9.42 0 5.27 4.04 2 8.933 2zm7.4 8.5c-3.14 0-5.533 1.889-5.533 4.216 0 2.576 2.062 4.348 5.495 4.217h1.687a2 2 0 01.833.181l2.597 1.191-.483-.856a2 2 0 01.12-2.155c.547-.757.818-1.607.818-2.578 0-2.273-2.434-4.216-5.534-4.216zM8.933 4C5.063 4 2 6.479 2 9.42c0 1.285.366 2.41 1.104 3.406a2 2 0 01.141 2.164L2.24 16.794l3.805-1.768c.342-.16.63-.235 1.004-.173.49.08 1.118.113 1.754.098a10.598 10.598 0 01-.003-.235c0-3.41 3.118-6.005 7.046-6.204-.483-1.587-1.476-2.739-2.834-3.5C11.844 4.358 10.431 4 8.933 4z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

